import { render, staticRenderFns } from "./SendMsgPopup.vue?vue&type=template&id=724c9b21&scoped=true"
import script from "./SendMsgPopup.vue?vue&type=script&lang=js"
export * from "./SendMsgPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c9b21",
  null
  
)

export default component.exports